module.exports = __webpack_public_path__ + "media/application/images/ui/email-top-25822314951e00338c2e703c508de1a0.gif";